module.exports = __webpack_public_path__ + "img/電気回路_6_5_2.f62f7e22.png";